import React, { useState, useEffect, Fragment } from 'react';
import Gallery from "react-photo-gallery";
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  CardImg,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { API_CONNECTWARE, post_API_Send_Email_Instructions } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../../propinfo/gallery/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
let arr = [];
export default function ConnectWareSettings({
  integration,
  integrationProperties,
  allProperties,
  saveIntegration,
  propertyId
}) {
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [emailInput, setEmailInput] = useState({
    email: "",
    placeHolder: ""
  });

  const [showEmailBox, setShowEmailBox] = useState(false);
  const [connectionSettings, setConnectionSettings] = useState(
    integration?.phoneSuiteIntegration?.connectionSettings || {
      serviceProviderName: 'Myma.ai',
      domain: 'hotelmyma.nlv.uc',
      serviceProviderLogo: '',
      sipGateway: '',
      originatingPhoneNumber: '',
      inboundTrunk: '',
      outboundTrunk: '',
    }
  );
  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [propertyList, setPropertyList] = useState([]);
  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    setList(integrationProperties);
    if (integration.name !== undefined && integration.name !== null) {
      setName(integration.name);
    }
    const property = allProperties.map((elem) => {
      elem.checked = false;
      result.forEach((lang) => {
        if (lang.id === elem.id) {
          elem.checked = true;
        }
      });
      return elem;
    });
    setPropertyList(property);
  }, [integrationProperties, allProperties]);

  const selectedImage = (image) => {
    setConnectionSettings({
      ...connectionSettings,
      serviceProviderLogo: image.src,
    });
  };

  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleCheckChange = (e) => {
    // if (e.target.checked) {
    //   arr[e.target.id] = e.target.value;
    // }
    // if (!e.target.checked) {
    //   arr[e.target.id] = undefined;
    // }
    // const filterList = arr.filter(elem => elem !== undefined || null);
    // setList(filterList);

    const values = propertyList.map((elem) => {
      if (elem.id === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    const propertyArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);
    setList(propertyArr);
  };

  // const handleSave = () => {
  //   if (connectionSettings.sipGateway === 'ConnectWare') {
  //     AxiosAPI({
  //       method: 'get',
  //       url: `${API_CONNECTWARE}/check-domain?domain=${connectionSettings?.domain}`,
  //     }).then((res) => {
  //       if (res.data.domain !== undefined && res.data.domain !== null) {
  //         saveIntegration({ connectionSettings: connectionSettings });
  //         arr = [];
  //         setList([]);
  //       } else {
  //         NotificationManager.error(
  //           '',
  //           'Domain is not correct.',
  //           3000,
  //           null,
  //           null,
  //           'error'
  //         );
  //       }
  //     });
  //   } else {
  //     saveIntegration({ connectionSettings: connectionSettings });
  //   }
  // };
  const handleSave = () => {
    let updatedSettings = { ...connectionSettings };

    // Always use "Myma.ai" as the service provider name
    updatedSettings.serviceProviderName = 'Myma.ai';

    // Apply read-only trunk values for specific gateways
    if (connectionSettings.sipGateway === 'SmartPABX') {
      updatedSettings.inboundTrunk = 'SmartPABX';
      updatedSettings.outboundTrunk = 'SmartPBX_Outbound';
    }

    if (connectionSettings.sipGateway === 'Twilio') {
      const trunk = 'Twilio-2gJVTp4G4zQSnjGL51qBnD';
      updatedSettings.inboundTrunk = trunk;
      updatedSettings.outboundTrunk = trunk;
    }

    // Validate ConnectWare domain
    if (connectionSettings.sipGateway === 'ConnectWare') {
      AxiosAPI({
        method: 'get',
        url: `${API_CONNECTWARE}/check-domain?domain=${updatedSettings.domain}`,
      }).then((res) => {
        if (res.data.domain) {
          saveIntegration({ connectionSettings: updatedSettings });
          setList([]);
        } else {
          NotificationManager.error(
            '',
            'Domain is not correct.',
            3000,
            null,
            null,
            'error'
          );
        }
      });
    } else {
      saveIntegration({ connectionSettings: updatedSettings });
    }
  };

  const handleChangeServieProviderName = (e) => {
    setConnectionSettings({
      ...connectionSettings,
      serviceProviderName: e.target.value,
    });
  };

  const handleChangeSIPGateway = (e) => {
    setConnectionSettings({
      ...connectionSettings,
      sipGateway: e.target.value,
    });
  };

  const handleChangeDomain = (e) => {
    setConnectionSettings({ ...connectionSettings, domain: e.target.value });
  };

  const handleMymaChange = (e) => {
    setConnectionSettings({
      ...connectionSettings,
      [e.target.name]: e.target.value,
    });
  };

  const Edit = () => {
    const infoIcon = (
      <span
        style={{ cursor: 'pointer' }}
        title="Extension example: 8888, Voice AI Phone Number is format +countrycode and number (no spaces)"
      >
        <i class="demo-icon simple-icon-info" />
      </span>
    );

    const readOnlyInput = (value) => (
      <Input
        className="form-control"
        value={value}
        disabled
        readOnly
      />
    );

    const getTrunkValues = (gateway) => {
      if (gateway === 'SmartPABX') {
        return {
          inboundTrunk: 'SmartPABX',
          outboundTrunk: 'SmartPBX_Outbound'
        };
      } else if (gateway === 'Twilio') {
        const trunkValue = 'Twilio-2gJVTp4G4zQSnjGL51qBnD';
        return {
          inboundTrunk: trunkValue,
          outboundTrunk: trunkValue
        };
      }
      return {
        inboundTrunk: connectionSettings.inboundTrunk,
        outboundTrunk: connectionSettings.outboundTrunk
      };
    };
    const SendEmail = () => {

      let data = {
        groupId: getGroupID(),
        intregationId: integration.id,
        propertyId: propertyId === "-1" ? null : propertyId,
        type: "Voice",
        ...emailInput
      };
      AxiosAPI({
        method: 'post',
        url: `${post_API_Send_Email_Instructions}`,
        data,
      })
    };
    const trunkValues = getTrunkValues(connectionSettings.sipGateway);

    return (
      <CardBody>
        <div className="text-center mb-2">
          <h6>SIP Gateway Settings</h6>
        </div>
        <Separator className="mb-3" />

        <Card className="m-4">
          <Colxx xxs="12" className="p-4">
            <div className="">
              {/* <div className="text-center mb-2">
                <CardImg
                  top
                  src={connectionSettings?.serviceProviderLogo}
                  alt="Card image cap"
                  className="img-thumbnail border-0 rounded-circle list-thumbnail"
                />
              </div>
              <div className="text-center mb-3">
                <Button
                  color="success"
                  size="xs"
                  className="mt-1"
                  onClick={togglegallery}
                >
                  Browse Service Provider Logo
                </Button>
              </div> */}
              <div className="text-left">
                <div className="mb-3">
                  <h6>Select SIP Gateway</h6>
                  <Input
                    type="select"
                    className="form-control"
                    name="sipGateway"
                    value={connectionSettings.sipGateway}
                    onChange={handleChangeSIPGateway}
                  >
                    <option value="">Please Select</option>
                    <option value="Myma.ai">Configurable SIP</option>
                    <option value="ConnectWare">Connectware by PhoneSuite</option>
                    <option value="SmartPABX">SmartPABX by Broadband Solution</option>
                    <option value="Twilio">Twilio</option>
                  </Input>
                </div>
                {/* <div className="mb-3">
                  <h6>Service Provider Name</h6>
                  <Input
                    className="form-control"
                    name="name"
                    defaultValue={connectionSettings.serviceProviderName}
                    onChange={handleChangeServieProviderName}
                  />
                </div> */}
                {connectionSettings.sipGateway === 'ConnectWare' && (
                  <div className="mb-3">
                    <h6>Domain (from ConnectWare)</h6>
                    <Input
                      className="form-control"
                      name="name"
                      defaultValue={connectionSettings.domain}
                      onChange={handleChangeDomain}
                    />
                  </div>
                )}

                {['Myma.ai', 'SmartPABX', 'Twilio'].includes(connectionSettings.sipGateway) && (
                  <div className="mb-3">
                    <h6>
                      Voice AI Phone Number or Extension {['SmartPABX', 'Twilio'].includes(connectionSettings.sipGateway) && infoIcon}
                    </h6>
                    <Input
                      className="form-control"
                      name="originatingPhoneNumber"
                      placeholder="+1615XXXXXXX"
                      value={connectionSettings.originatingPhoneNumber}
                      onChange={handleMymaChange}
                    />
                  </div>
                )}

                {connectionSettings.sipGateway === 'Myma.ai' && (
                  <>
                    <div className="mb-3">
                      <h6>Inbound Trunk Name</h6>
                      <Input
                        className="form-control"
                        name="inboundTrunk"
                        value={connectionSettings.inboundTrunk}
                        onChange={handleMymaChange}
                      />
                    </div>
                    <div className="mb-3">
                      <h6>Outbound Trunk Name</h6>
                      <Input
                        className="form-control"
                        name="outboundTrunk"
                        value={connectionSettings.outboundTrunk}
                        onChange={handleMymaChange}
                      />
                    </div>
                  </>
                )}

                {['SmartPABX', 'Twilio'].includes(connectionSettings.sipGateway) && (
                  <>
                    <div className="mb-3">
                      <h6>Inbound Trunk Name</h6>
                      {readOnlyInput(trunkValues.inboundTrunk)}
                    </div>
                    <div className="mb-3">
                      <h6>Outbound Trunk Name</h6>
                      {readOnlyInput(trunkValues.outboundTrunk)}
                    </div>
                  </>
                )}
                <div className="text-center">
                  <Button className='mt-2' color="primary" outline size="xs" onClick={() => setShowEmailBox(!showEmailBox)}>
                    Send instructions to Phone Administrator
                  </Button>
                </div>
              </div>
            </div>
          </Colxx>
        </Card>
        <Separator className="my-3" />

        <div className="text-center mt-4 mb-2">
          <Button color="primary" className='mr-1' size="xs" onClick={handleSave}>
            Save
          </Button>
          <Button className='ml-1' size="xs" color="secondary" onClick={() => setIsEditing(!isEditing)}>
            Cancel
          </Button>
        </div>

        <Modal className='intregation-modal-content' style={{ borderRadius: '10px', marginTop: '100px' }} isOpen={showEmailBox} toggle={() => setShowEmailBox(!showEmailBox)}>
          <ModalHeader toggle={() => setShowEmailBox(!showEmailBox)}>
            Send instructions to Phone Administrator
          </ModalHeader>
          <ModalBody>
            <Card className="">
              <Colxx xxs="12" className="py-2">
                <div className="my-2">
                  <b>Email:</b>
                  <p>
                    <Input
                      className='my-2'
                      type="text"
                      name="email"
                      value={emailInput.email}
                      placeholder="E-mail"
                      onChange={(e) => setEmailInput({ ...emailInput, email: e.target.value })}
                    />
                  </p>
                  <b>Message:</b>
                  <p>
                    <Input
                      className='my-2'
                      type="text"
                      name="placeHolder"
                      value={emailInput.placeHolder}
                      placeholder="Message"
                      onChange={(e) => setEmailInput({ ...emailInput, placeHolder: e.target.value })}
                    />
                  </p>
                </div>
              </Colxx>
            </Card>
          </ModalBody>
          <ModalFooter className='justify-content-center'>
            <Button
              color="success"
              size="xs"
              onClick={() => { SendEmail(); setEmailInput({ email: "", placeHolder: "" }); setShowEmailBox(!showEmailBox); }}
            >
              <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon><span className='ml-2' >Send</span>
            </Button>
          </ModalFooter>
        </Modal>
        {/* {ImageGalleryButton()} */}
      </CardBody>
    );
  };

  return <Card className="mb-4"> {Edit()}</Card>;
}
